import { SxProps, Theme, styled } from "@mui/material";
import searchSVG from "../../../../assets/images/search.svg";

interface Props {
  sxClass?: SxProps<Theme>;
}

export const SearchIcon = ({ sxClass }: Props) => {
  return <StyledImage sx={sxClass} src={searchSVG.src} alt="search-icon" />;
};

const StyledImage = styled("img")({});
